import * as gqlTypes from "@hydrologiq/gql/graphql"
import ActivityCreate from "./ActivityCreate"
import { useState } from "react"
import { Button, HStack, Text } from "@chakra-ui/react"
import Dialog from "@hydrologiq/shared/chakra/Dialog"

interface ActivityCreateWorkflowProps {
  asset: gqlTypes.Asset
  openOverride: boolean
  onOpenChange: (isOpen: boolean) => void
  onActivityCreated: () => void
  defaultStartDate: string
  allowAnyAsset: boolean
}
function ActivityCreateWorkflow(props: ActivityCreateWorkflowProps) {
  const { asset, openOverride, onOpenChange, onActivityCreated, defaultStartDate } = props
  const [view, setView] = useState<"select" | "create-activity" | "create-fulfilment">("select")

  const [selectOpen, setSelectOpen] = useState(openOverride)

  if (view === "select") {
    return (
      <Dialog title={"Schedule"} loading={false} disabled={false} open={selectOpen} setOpen={setSelectOpen}>
        <Text fontWeight="bold">Please choose the type of item you’d like to schedule.</Text>
        <Text>
          An activity can fall under multiple categories (e.g., Movement, Filling, or Inspection).
          <br /> Fulfilments must always be associated with an order.
        </Text>
        <HStack width="100%" mt={4}>
          <Button width="50%" variant="hydrologiq_primary" size="sm" onClick={() => setView("create-activity")}>
            Activity
          </Button>
          <Button width="50%" variant="hydrologiq_primary" size="sm" onClick={() => setView("create-fulfilment")}>
            Fulfilment
          </Button>
        </HStack>
      </Dialog>
    )
  }

  return (
    <ActivityCreate
      asset={asset as any}
      activities={[]}
      activityKinds={
        view === "create-activity"
          ? [
              gqlTypes.ActivityKind.Movement,
              gqlTypes.ActivityKind.Filling,
              gqlTypes.ActivityKind.Maintenance,
              gqlTypes.ActivityKind.Inspection,
              gqlTypes.ActivityKind.Hold,
            ]
          : [gqlTypes.ActivityKind.Fulfilment]
      }
      openOverride={openOverride}
      onOpenChange={(isOpen) => {
        onOpenChange(isOpen)
      }}
      onActivityCreated={() => {
        onActivityCreated?.()
      }}
      defaultStartDate={defaultStartDate}
      allowAnyAsset={false}
      trigger={<></>}
    />
  )
}

export default ActivityCreateWorkflow
